<template>
  <checker-view :title="title" :permitCheck=true type="mooring" />
</template>

<script>
import CheckerView from '@/components/checker'

export default {
  components: {CheckerView},
  data: () => ({title: 'MAST Online Mooring Registration Check'})
}
</script>



// WEBPACK FOOTER //
// src/views/mooring.vue